const SITE = "https://dmitriderevjanko.com";

export const HOMEPAGE_SEO = {
  title: "Dmitri Derevjanko | AI/ML Solutions Engineer",
  description:
    "Dmitri Derevjanko is an AI/ML Solutions Engineer and Digitalization and Data Management Expert at AI & Robotics Estonia (AIRE). AI Solutions Engineer at Adapter. 10+ independent live projects. 100+ professional workflows delivered. Tallinn, Estonia.",
  canonical: `${SITE}/`,
  image: `${SITE}/og-image-1200x630.jpg?v=6`,
  ogType: "website"
};

function upsertMetaByName(name, content) {
  if (!content) return;
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertMetaByProperty(property, content) {
  if (!content) return;
  let tag = document.head.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertCanonical(href) {
  let tag = document.head.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let tag = document.getElementById(id);
  if (!data) {
    if (tag) {
      tag.remove();
    }
    return;
  }
  if (!tag) {
    tag = document.createElement("script");
    tag.type = "application/ld+json";
    tag.id = id;
    document.head.appendChild(tag);
  }
  tag.textContent = JSON.stringify(data);
}

export function applySeo({
  title,
  description,
  canonical,
  image,
  ogType,
  jsonLd,
  jsonLdId
}) {
  if (typeof document === "undefined") {
    return;
  }
  if (title) {
    document.title = title;
  }
  upsertMetaByName("description", description);
  upsertCanonical(canonical);
  upsertMetaByProperty("og:type", ogType || "website");
  upsertMetaByProperty("og:title", title);
  upsertMetaByProperty("og:description", description);
  upsertMetaByProperty("og:url", canonical);
  upsertMetaByProperty("og:image", image);
  upsertMetaByName("twitter:title", title);
  upsertMetaByName("twitter:description", description);
  upsertMetaByName("twitter:url", canonical);
  if (image) {
    upsertMetaByName("twitter:image", image);
  }
  if (jsonLdId) {
    upsertJsonLd(jsonLdId, jsonLd);
  }
}
